// Vanilla JS Accordion functionality
function slideDown(el) {
    el.style.opacity = "1";
    el.style.maxHeight = el.scrollHeight + "px";
}

function slideUp(el) {
    el.style.maxHeight = "0px";
    window.setTimeout(function(){
        el.style.opacity = 0;
    }, 500);
}

// helper
// helper functions to toggle a class name on an element
function removeClass(el, classname) {
    el.className = el.className.replace(" " + classname, "");
}

function addClass(el, classname) {
    el.className += " " + classname;
}

function hasClass(el, classname) {
    return ((" " + el.className + " ").replace(/[\t\r\n]/g, " ").indexOf(" " + classname + " ") >= 0);
}

function toggleClass(el, classname) {
    if (hasClass(el, classname)) {
        removeClass(el, classname);
    } else {
        addClass(el, classname);
    }
}

function findAncestor(el, cls) {
    while ((el = el.parentElement) && !el.classList.contains(cls));
    return el;
}


// function to close the accordion
function close_accordion_section(title, content) {
    removeClass(title, "active");
    slideUp(content);
    removeClass(content, "open");
}
// function to open the accordion
function open_accordion_section(title, content) {
    addClass(title, "active");
    slideDown(content);
    addClass(content, "open");
}

// EduEvo accordion script, converted to vanilla JS
var accordEls = document.querySelectorAll('.accordion');
for (var i = 0; i < accordEls.length; i++) {
    curEl = accordEls[i];

    var titles = curEl.querySelectorAll('.accordion-section-title');
    for (var j = 0; j < titles.length; j++) {
        titles[j].onclick = function (e) {
            e.preventDefault();
            var title = e.target;
            var curHref = e.target.getAttribute('href');
            var content = document.querySelector(curHref);
            if (hasClass(title, 'active')) {
                close_accordion_section(title, content);
            } else {
                open_accordion_section(title, content);
            }
        }
    }
}
window.addEventListener('resize', function (e) {
    var openAccs = document.querySelectorAll('.accordion-section-content.open');
    if (openAccs == null) {
        return;
    }
    for (var i = 0; i <  openAccs.length; i++) {
        openAccs[i].style.maxHeight = openAccs[i].scrollHeight + "px";
    }
});
